class RegistrationCleaner {
  static EXPIRATION_TIME = 30 * 60 * 1000; 
  static CHECK_INTERVAL =   30 * 60 * 1000;  
  static checkAndClean() {
    const savedData = localStorage.getItem('registrationData');
    if (!savedData) return false;
    
    try {
      const parsedData = JSON.parse(savedData);
      const lastUpdated = new Date(parsedData.lastUpdated).getTime();
      const now = Date.now();
      
      if (now - lastUpdated > this.EXPIRATION_TIME) {
        this.cleanAll();
        return true; 
      }
      return false; 
    } catch (error) {
      console.error('Error parsing registration data:', error);
      this.cleanAll();
      return true;
    }
  }
  
  static cleanAll() {
    localStorage.removeItem('registrationData');
    sessionStorage.removeItem('ssmFile');
    // console.log('Registration data cleaned due to expiration');
  }
  
  static updateTimestamp() {
    const savedData = localStorage.getItem('registrationData');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        parsedData.lastUpdated = new Date().toISOString();
        localStorage.setItem('registrationData', JSON.stringify(parsedData));
      } catch (error) {
        console.error('Error updating timestamp:', error);
      }
    }
  }
  
  static setupAutoClean(onExpired) {
    const checkAndNotify = () => {
      const wasExpired = this.checkAndClean();
      if (wasExpired && onExpired) {
        onExpired();
      }
    };
    
    checkAndNotify();

    const interval = setInterval(checkAndNotify, this.CHECK_INTERVAL);
    
    return () => clearInterval(interval);
  }
}

export default RegistrationCleaner;